import React from 'react'
import Dashboard from '../../dashboard/index'
import RequestScooterView from './page'

const RequestScooter = () => {
  return <Dashboard component={<RequestScooterView />} />
}

export default RequestScooter
